import { foundationCheckups } from "./learningCheckupFoundations";
import { marketCheckups } from "./learningCheckupMarkets";

// Cross-topic scenarios reuse stable lesson IDs for targeted reading.
export const learningCheckups = [...foundationCheckups, ...marketCheckups];
